import PropTypes from 'prop-types';

import CONSTANTS from 'src/store/constants';

import ActuarialMode from './actuarial';
import ClassifierMode from './classifier';

const ACT_MODEL_TYPES = CONSTANTS.TAL_MODEL.TAGS.slice(2);

export default function LiftCharts(props) {
  // eslint-disable-next-line react/destructuring-assignment
  const { dataModelType } = props.modelView.model;
  if (dataModelType === 'CLASSIFIER') return ClassifierMode(props);
  if (ACT_MODEL_TYPES.includes(dataModelType))
    return ActuarialMode({
      ...props,
      chartMeta: CONSTANTS.TAL_MODEL.ACT_STYLING[dataModelType],
    });
  return null;
}

LiftCharts.propTypes = {
  modelView: PropTypes.shape({
    model: PropTypes.shape({
      name: PropTypes.string,
      dataModelType: PropTypes.string.isRequired,
      modelData: PropTypes.shape({
        dataPayload: PropTypes.shape({
          lift_scores: PropTypes.arrayOf(
            PropTypes.shape({
              percentile: PropTypes.arrayOf(PropTypes.number),
              lift: PropTypes.arrayOf(PropTypes.number),
              total_users: PropTypes.number.isRequired,
              engaged_users: PropTypes.number.isRequired,
            })
          ),
        }).isRequired,
      }),
    }),
    gradient: PropTypes.string.isRequired,
    fetchModelStatus: PropTypes.oneOf([PropTypes.string, undefined]).isRequired,
    numBins: PropTypes.number.isRequired,
    chart: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
  }).isRequired,
};
